import { OwlOptions } from 'ngx-owl-carousel-o';

export const menuBarOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 300,
    stagePadding: 50,
    autoWidth: true,
    responsive: {
        0: { items: 1 },
        554: { items: 2 },
        831: { items: 3 },
        1108: { items: 4 },
        1662: { items: 5 },
        1939: { items: 6 },
    },
    nav: false,
};
